import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Column, Row, Typography } from 'seagull';
import { ColorSelectorWithPopup } from '~/client-flow/clientOb/BrandingControllers/ColorSelectorWithPopup';
import { PrimaryBackgroundColorPopup } from '~/client-flow/clientOb/BrandingControllers/PrimaryBackgroundColorPopup';
import { LogoPicker } from '~/components/LogoPicker/LogoPicker';
import { useLocaleKeys } from '~/i18n';
import { BrandPreview } from '../BrandPreview/BrandPreview';
import styles from './BrandSettingsBody.module.scss';
export const BrandSettingsBody = (param)=>{
    let { testId, previewTestId, branding, errors, setBranding, logoImage, onLogoChange, saving, column } = param;
    const { t: brandSettingsTexts } = useLocaleKeys('pages.businessDetails.brandSettings');
    const preview = /*#__PURE__*/ _jsx(BrandPreview, {
        testId: previewTestId !== null && previewTestId !== void 0 ? previewTestId : "".concat(testId, "-preview"),
        image: logoImage,
        brandColor: branding.buttonPrimary,
        primaryBgStart: branding.backgroundGradientStart,
        primaryBgEnd: branding.backgroundGradientEnd,
        secondaryBgColor: branding.backgroundStandard,
        loading: saving
    });
    const colorSelectors = /*#__PURE__*/ _jsxs(Row, {
        gap: 12,
        alignItems: "center",
        className: styles.colorSelectors,
        children: [
            /*#__PURE__*/ _jsx(ColorSelectorWithPopup, {
                branding: branding,
                colorKey: "buttonPrimary",
                hasError: errors.has('buttonPrimary'),
                size: "l",
                onChange: setBranding
            }),
            /*#__PURE__*/ _jsx(PrimaryBackgroundColorPopup, {
                branding: branding,
                hasError: errors.has('backgroundGradientStart') || errors.has('backgroundGradientEnd'),
                size: "l",
                onChange: setBranding
            }),
            /*#__PURE__*/ _jsx(ColorSelectorWithPopup, {
                branding: branding,
                colorKey: "backgroundStandard",
                hasError: errors.has('backgroundStandard'),
                size: "l",
                onChange: setBranding
            })
        ]
    });
    if (column) {
        return /*#__PURE__*/ _jsxs(Column, {
            className: styles.columnRoot,
            gap: 16,
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    className: styles.columnPreviewWrapper,
                    children: preview
                }),
                /*#__PURE__*/ _jsx(Box, {
                    className: styles.columnLogoWrapper,
                    children: /*#__PURE__*/ _jsx(LogoPicker, {
                        image: logoImage,
                        onChange: onLogoChange,
                        testId: "".concat(testId, "-logo"),
                        showEditButton: true,
                        editButtonLabel: brandSettingsTexts.changeLogo()
                    })
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "paragraph2",
                            weight: "light",
                            children: brandSettingsTexts.brandColors()
                        }),
                        colorSelectors
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Row, {
        className: styles.root,
        gap: 24,
        alignItems: "stretch",
        children: [
            /*#__PURE__*/ _jsxs(Column, {
                className: styles.leftColumn,
                gap: 20,
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        className: styles.logoPickerWrapper,
                        children: /*#__PURE__*/ _jsx(LogoPicker, {
                            image: logoImage,
                            onChange: onLogoChange,
                            testId: "".concat(testId, "-logo"),
                            showEditButton: true,
                            editButtonLabel: brandSettingsTexts.changeLogo()
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        gap: 12,
                        className: styles.colorsWrapper,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraph1",
                                weight: "light",
                                children: brandSettingsTexts.brandColors()
                            }),
                            colorSelectors
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                className: styles.previewWrapper,
                children: preview
            })
        ]
    });
};
